import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BootstrapService {
    private readonly ready = signal<boolean>(false);

    isReady(): boolean {
        return this.ready();
    }

    markReady(): void {
        this.ready.set(true);
    }

    reset(): void {
        this.ready.set(false);
    }
}
